import React, { useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { ConfigContext } from "../context/GlobalContext";
import CustomerListLayer from "../components/CustomerListLayer";
import { Languages } from "../Utils/Languages";


const CustomerListPage = () => {

  const { state } = useContext(ConfigContext);

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title={Languages[state?.LANGUAGE].customers_list} />

        {/* InvoiceListLayer */}
        <CustomerListLayer />

      </MasterLayout>

    </>
  );
};

export default CustomerListPage;
